import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedPreferencesService } from '../../services/shared-preferences.service';
import { Storage } from '../../utilities/storage';

@Component({
  selector: 'category-select',
  templateUrl: './category-select.component.html',
  styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent implements OnInit {
  @Input()  dropdown: Boolean;

  @Input() selectedCategory:any = null;

  @Output() selectedCategoryChange = new EventEmitter<any>();

  categories: any[];

  constructor(
    public sharedPreferencesService: SharedPreferencesService
  ) {
    this.categories = this.sharedPreferencesService.categories;

    this.selectedCategory = this.getCategoryStorage();
  }

  ngOnInit() {
    // this.selectedCategoryChange.emit(this.selectedCategory);
  }

  selectCategory(category) {
    this.selectedCategory = category;
    this.selectedCategoryChange.emit(category);
  }

  getCategoryStorage() {
    let storageValue = Storage.get('selected_category') ? Storage.get('selected_category') : 1;

    return this.sharedPreferencesService.getCategory('id', storageValue);
  }

}



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/components/category-select/category-select.component.ts